import { supabase } from '@/integrations/supabase/client';

export type HeroVariant = 'A' | 'B';

export type HeroEventType =
  | 'variant_assigned'
  | 'headline_view'
  | 'prompt_view'
  | 'prompt_click'
  | 'cta_primary_click'
  | 'cta_secondary_click'
  | 'search_submit'
  | 'quick_pick_click';

const VARIANT_KEY = 'lumza:hero_variant';
const SESSION_KEY = 'lumza:hero_session';

export const getHeroVariant = (): HeroVariant => {
  if (typeof window === 'undefined') return 'A';
  try {
    const existing = localStorage.getItem(VARIANT_KEY);
    if (existing === 'A' || existing === 'B') return existing;
    const assigned: HeroVariant = Math.random() < 0.5 ? 'A' : 'B';
    localStorage.setItem(VARIANT_KEY, assigned);
    return assigned;
  } catch {
    return Math.random() < 0.5 ? 'A' : 'B';
  }
};

export const getSessionId = (): string => {
  if (typeof window === 'undefined') return 'ssr';
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return `s_${Date.now()}`;
  }
};

export type TimeBucket = 'late_night' | 'deep_night' | 'pre_dawn' | 'daytime';

export const getTimeBucket = (date = new Date()): TimeBucket => {
  const h = date.getHours();
  if (h >= 23 || h < 2) return 'late_night';
  if (h >= 2 && h < 5) return 'deep_night';
  if (h >= 5 && h < 7) return 'pre_dawn';
  return 'daytime';
};

export const trackHeroEvent = async (
  event_type: HeroEventType,
  payload: {
    variant: HeroVariant;
    prompt_index?: number;
    prompt_label?: string;
    time_bucket?: string;
    metadata?: Record<string, unknown>;
  }
) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from('hero_events').insert([{
      session_id: getSessionId(),
      user_id: user?.id ?? null,
      variant: payload.variant,
      event_type,
      prompt_index: payload.prompt_index ?? null,
      prompt_label: payload.prompt_label ?? null,
      time_bucket: payload.time_bucket ?? null,
      metadata: (payload.metadata ?? null) as never,
    }]);
  } catch (err) {
    // Never throw from analytics
    console.debug('hero analytics failed', err);
  }
};
